import React, { Component, Fragment } from "react";
import PageTop from "../src/Resources/PageTop";
import ViewMore from "../src/Resources/ViewMore";
import withAppData from "../src/HOC/withAppData";
import Table from "../src/Resources/Forms/Table";
import { _cloneArray } from "../src/Utils/helpers";
import { GET } from "../src/Utils/api";
import PmShipmentReconcilationDetails from "./PmShipmentReconcilationDetails";
import Loading from "../src/Loaders/Loading";
import "../src/Styles/Pages/pmorderprocessing.scss";
//import DriverStore from "../src/Component/Inventory/RtoStock/DriverResell/DriverStore";
//import localForage from "localforage";

const tableHeadings = [
	{ text: "Shipment No" },
	{ text: "Item Picked" },
	{ text: "No of Deliveries" },
	{ text: "Stock Manager" },
	{ text: "Reco Manager" },
	{ text: "Status" },
];

const tableColumns = [
	{
		text: "shipmentId",
		label: "Shipment No:",
	},
	{
		text: "itemsPicked",
		label: "Item Picked:",
		suffix: "ctn",
	},
	{
		text: "numberOfOrders",
		label: "No of Deliveries",
	},
	{
		text: "stockManagerName",
		label: "Stock Manager",
	},
	{
		text: "reconcileManagerName",
		label: "Reco Manager",
	},
	{
		text: "reconcilationStatus",
		label: "Status:",
		type: "tag",
		tableTagType: "reconcilationStatus",
		classNames: "oms-table-status delivered ",
	},
];
class PMDriverReconcilation extends Component {
	constructor(props) {
		super(props);
		this.state = {
			userLocation: this.props.context.userLocation,
			showLoading: true,
			shipmentData: {
				shipments: [],
				TotalShipmentCount: [
					{
						total: 0,
						totalPending: 0,
						totalProcessed: 0,
					},
				],
			},
			shipmentList: [],
			filterCount: 0,
			defaultDateType: 0,
			shipmentDetails: {},
			isDriver: ["reseller biker", "reseller van driver"].includes(
				this.props.context.role.toLowerCase(),
			),
			sliceValue: 10,
			searchValue: "",
			pageNumber: 1,
			activeTab: "pending",
			activeTabIndex: 0,
			searchingTimeout: 0,
			isRefresh: false,

			showOTPModal: false,
			isLoadingOTP: false,
			otpCode: null,
			otpVerified: false,
			isDepotDriver: props.context.isDepot,
			isInitiatingOTP: true,
		};
	}
	componentDidMount() {
		//check if user has permission to view page
		// if (!this.props.context.hasPermission(408, 2)) {
			// this.props.history.replace("/");
		// } else {
			document.title = "Reconcilation";
			// this.props.context.updatePageTitle("Reconcilation");
			this.GetShipments(0);
		// }
	}
	componentDidUpdate(prevProps, prevState) {
		if (
			prevState.activeTab !== this.state.activeTab ||
			prevState.isRefresh !== this.state.isRefresh
		) {
			this.createShipmentList();
		}
	}
	GetShipments = async flag => {
		//flag=1 means push data in previous data we are calling from load more button
		let requestUrl = `PickerShipment/GetShipments?flag=1&pageNo=${
			this.state.pageNumber
		}&recordPerPage=${50}`;
		if (this.state.searchValue) {
			requestUrl = `${requestUrl}&search=${this.state.searchValue}`;
		}
		const result = await GET(requestUrl);
		if (!result.error) {
			this.setState({ showLoading: false }, () => {
				let resultData = result;
				if (
					flag === 1 &&
					this.state.shipmentData &&
					this.state.shipmentData.shipments
				) {
					resultData.shipments = this.state.shipmentData.shipments.concat(
						result.shipments,
					);
				}
				this.setState({
					shipmentData: resultData,
					isRefresh: !this.state.isRefresh,
				});
				this.setState({ shipmentList: _cloneArray(result.shipments || []) });
			});
		} else {
			this.setState({ showLoading: false });
		}
	};
	loadMoreShipment = () => {
		if (this.state.shipmentList.length > this.state.sliceValue) {
			if (this.state.shipmentList.length - this.state.sliceValue === 20) {
				if (
					this.state.shipmentData.TotalShipmentCount[0][
						this.state.activeTabIndex === 0
							? "totalPending"
							: this.state.activeTabIndex === 1
							? "totalProcessed"
							: "total"
					] > this.state.shipmentList.length
				) {
					this.setState(
						{
							pageNumber: this.state.pageNumber + 1,
							loadingMoreShipment: false,
						},
						() => {
							this.GetShipments(1);
						},
					);
				}
			}
			this.setState({ sliceValue: this.state.sliceValue + 10 });
			return;
		}
	};
	createShipmentList = flag => {
		if (this.state.shipmentData.shipments) {
			let activeShipment = _cloneArray(this.state.shipmentData.shipments);
			if (activeShipment) {
				const { activeTab } = this.state;
				const pendingShipment = activeShipment.filter(el => !el.isProcessed);
				const processedShipment = activeShipment.filter(el => el.isProcessed);
				let shipmentList = [];
				if (activeTab === "pending") {
					shipmentList = pendingShipment;
				} else if (activeTab === "processed") {
					shipmentList = processedShipment;
				} else {
					shipmentList = activeShipment;
				}
				this.setState({
					shipmentList,
					showLoader: false,
					loadingMoreShipment: false,
				});
			}
		}
	};
	searchShipments = value => {
		this.setState({ searchValue: value, showLoader: true, sliceValue: 10 });
		if (this.state.searchingTimeout) {
			clearTimeout(this.state.searchingTimeout);
		}
		if (value) {
			value = value.toLowerCase();
		}

		this.setState({
			searchingTimeout: setTimeout(() => {
				this.GetShipments(0);
			}, 1000),
		});
	};
	resetFilter = () => {};

	setShowReconcilation = (flag, activeTabIndex) => {
		this.setState(
			{ showReconcilation: flag, activeTabIndex: activeTabIndex },
			() => {
				this.GetShipments(0);
			},
		);
	};

	verifyOtpProcess = async id => {
		this.setState({ isLoadingOTP: true });
		const shipmentId = id || this.state.shipmentDetails.shipmentId;
		const requestUrl = `Depot/ScoutOTPConfirmation?shipmentId=${shipmentId}&flag=2`;
		const response = await GET(requestUrl);

		if (!response.error && response) {
			this.setState({ showOTPModal: false, otpVerified: true }, () => {
				this.props.context.showAlert("OTP Confirmed", "success");
				this.setState({ isLoadingOTP: false });
			});
			return true;
		}
		this.setState({ isLoadingOTP: false });
		return false;
	};

	getOtpCode = async id => {
		const requestUrl = `Depot/GetDepotPickListItems?shipmentId=${id}&flag=2`;
		const result = await GET(requestUrl);

		if (!result.error) {
			this.setState({ otpCode: result.OTP });
		} else {
			this.props.context.showToast("Please try again", "error");
			this.setState({ showOTPModal: false });
		}
		this.setState({ isInitiatingOTP: false });
	};

	initiateOtpProcess = async prm => {
		this.setState({ showOTPModal: true, shipmentDetails: prm });

		const fulfilledValue = await this.verifyOtpProcess(prm.shipmentId);
		if (fulfilledValue) {
			this.setState({ showOTPModal: false });
		} else {
			const payload = {
				ShipmentId: prm.shipmentId,
				CustomerId: this.props.context.userId,
				Flag: 2,
			};
			const requestUrl = `Depot/AddDepotDistributorDriverOTP`;
			let result = await POST(requestUrl, payload);

			if (!result.error) {
				this.getOtpCode(prm.shipmentId);
			} else {
				this.props.context.showToast("Please try again", "error");
			}
		}
	};

	render() {
		return (
			<Fragment>
				{this.state.showReconcilation ? (
					<PmShipmentReconcilationDetails
						shipmentDetails={this.state.shipmentDetails}
						setShowReconcilation={this.setShowReconcilation}
						activeTabIndex={this.state.activeTabIndex}
					/>
				) : (
					<Fragment>
						{this.state.showLoading ? (
							<Loading size={"4px"} margin={"80px auto 150px"} />
						) : (
							<Fragment>
								<div className="pm-driver-recon-top">
									<PageTop
										//showFilter={() => console.log("i am filter")}
										value={this.state.searchValue}
										//openedSearch={true}
										summary={[
											{
												text: "Pending",
												value: this.state.shipmentData.TotalShipmentCount[0]
													.totalPending,
											},
											{
												text: "Closed",
												value: this.state.shipmentData.TotalShipmentCount[0]
													.totalProcessed,
											},
											{
												text: "All",
												value: this.state.shipmentData.TotalShipmentCount[0]
													.total,
											},
										]}
										isTab
										activeTabIndex={this.state.activeTabIndex}
										showLoader={false}
										onTabChange={index => {
											this.setState({
												activeTab:
													index === 0
														? "pending"
														: index === 1
														? "processed"
														: "all",
												activeTabIndex: index,
												sliceValue: 10,
											});
										}}
										onSearch={value => this.searchShipments(value)}
									/>
								</div>
								<Table
									headings={tableHeadings}
									columns={tableColumns}
									fields={this.state.shipmentList}
									emptyText={"No shipment found"}
									columnClick={prm => {
										this.setState({
											showReconcilation: true,
											shipmentDetails: prm,
										});
									}}
									sliceValue={this.state.sliceValue}
									viewMore={
										this.state.shipmentList.length > this.state.sliceValue && (
											<ViewMore
												load={() => this.loadMoreShipment()}
												loading={this.state.loadingMoreShipment}
											/>
										)
									}
									showViewMore={true}
									subMenuHideId={"shipmentStatusId"}
									subMenuOptions={[
										this.state.isDepotDriver && {
											text: "Confirm Reco",
											onClick: prm => this.initiateOtpProcess(prm),
											hideId: "5,8",
										},
									].filter(f => f)}
								></Table>
							</Fragment>
						)}

						{this.state.showOTPModal && (
							<Modal
								header={"Confirm Stock Reco"}
								width={"350px"}
								closeModal={() => {
									this.setState({
										showOTPModal: false,
										otpCode: "",
										showLoading: false,
									});
								}}
							>
								{this.state.isInitiatingOTP && !this.state.otpCode ? (
									<Loading size={"4px"} margin={"50px auto 150px"} />
								) : (
									<div style={{ minHeight: "180px" }}>
										<div style={otpStyle}>
											<p style={otpTextStyle}>OTP</p>
											<p style={otpTextStyle}>{this.state.otpCode}</p>
										</div>
										<div style={otpNoteStyle}>
											Please give this OTP code to the Distributor to confirm
											Reconciliation
										</div>
										<div className="modal-submit">
											<Button
												type="default"
												text="Close"
												onClick={() => {
													this.setState({
														showOTPModal: false,
														otpCode: "",
														showLoading: false,
													});
												}}
											/>
											<Button
												type="primary"
												text="Verify OTP"
												onClick={() => this.verifyOtpProcess()}
												loading={this.state.isLoadingOTP}
											/>
										</div>
									</div>
								)}
							</Modal>
						)}
					</Fragment>
				)}
			</Fragment>
		);
	}
}

const otpStyle = {
	display: "flex",
	flexDirection: "row",
	justifyContent: "space-between",
	padding: "12px",
	backgroundColor: "#e6effa",
	borderRadius: "8px",
};

const otpTextStyle = {
	fontWeight: "700",
	fontSize: "16px",
	lineHeight: "16px",
	color: "#015fd1",
};

const otpNoteStyle = {
	fontWeight: "bold",
	textAlign: "center",
	marginTop: "20px",
};

export default withAppData(PMDriverReconcilation);
